import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contact.scss";
import Title from "../ui-components/title/title";
import ContactInfo from './contactInfo/contactInfo';
import ContactSocial from './contactInfo/contactSocial';
import Modal from '../contact-modal/Modal';

import ContactBackground from '../../assets/contact/bg.png';

// Translation Data for both languages
const translations = {
  en: {
    contactTitle: "CONTACT US",
    thankYouMessage: `Thank you for considering our cleaning company for your cleaning needs.
                      We are always here to help you achieve a cleaner and healthier environment.
                      For more information about our services or to schedule an appointment,
                      feel free to contact us.`,
  },
  ar: {
    contactTitle: "اتصل بنا",
    thankYouMessage: `شكرًا لاختيارك شركتنا لتنظيف احتياجاتك.
                      نحن هنا دائمًا لمساعدتك في تحقيق بيئة أنظف وأكثر صحة.
                      لمزيد من المعلومات حول خدماتنا أو لتحديد موعد،
                      لا تتردد في الاتصال بنا.`,
  },
};

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      message: "",
      sending: false,
      successModal: false,
      errorModal: false,
    };
  }

  inputHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // SUCCESS MODAL
  showSuccessModal = () => {
    this.setState({ successModal: true, sending: false });
    this.resetForm();
  };

  // ERROR MODAL
  showErrorModal = () => {
    this.setState({ errorModal: true, sending: false });
    this.resetForm();
  };

  // RESET CONTACT FORM
  resetForm() {
    this.setState({ name: "", email: "", message: "" });
  }

  // CLOSE ALL MODALS
  closeModal = () => {
    this.setState({ successModal: false, errorModal: false });
  };

  render() {
    const { language } = this.props; // Get the current language prop
    const { successModal, errorModal } = this.state;

    let modalRender = null;
    if (successModal) {
      modalRender = <Modal closeModal={this.closeModal} status="success" />;
    } else if (errorModal) {
      modalRender = <Modal closeModal={this.closeModal} status="error" />;
    }

    return (
      <div id="contact">
        {modalRender}
        <div className="wrapper">
          <Title title={translations[language]?.contactTitle || "CONTACT US"} />
          <div className="thank-you-message">
            <p>{translations[language]?.thankYouMessage || translations.en.thankYouMessage}</p>
          </div>
          <ContactInfo language={language} />
          <ContactSocial language={language} />
        </div>
      </div>
    );
  }
}

export default Contact;
